export const loadProductsByLang = async (lang = "tr") => {
  const res = await fetch(`/products/${lang}.json`);
  if (!res.ok) {
    throw new Error(`Dil dosyası (${lang}) bulunamadı`);
  }

  const products = await res.json();
  return products;
};
export const loadValidProducts = async (lang = "en") => {
  const [enRes, trRes, arRes] = await Promise.all([
    fetch("/products/en.json"),
    fetch("/products/tr.json"),
    fetch("/products/ar.json"),
  ]);

  if (!enRes.ok || !trRes.ok || !arRes.ok) {
    throw new Error("JSON dosyalarına ulaşılamadı");
  }

  const [enProducts, trProducts, arProducts] = await Promise.all([
    enRes.json(),
    trRes.json(),
    arRes.json(),
  ]);

  const maps = {
    tr: new Map(trProducts.map((p) => [p.stock_code, p])),
    ar: new Map(arProducts.map((p) => [p.stock_code, p])),
  };

  const selectedMap = maps[lang] || new Map();

  // Her en.json ürününe karşılık localized varsa override
  return enProducts.map((p) => {
    const localized = selectedMap.get(p.stock_code);
    return {
      ...p,
      ...(localized || {}),
    };
  });
};

export const loadProductsWithLangFallback = async (lang = "en") => {
  const apiRes = await fetch("https://apimukemel.com/api/index.php/products");
  const apiProducts = await apiRes.json();

  const [trRes, arRes] = await Promise.all([
    fetch("/products/tr.json"),
    fetch("/products/ar.json"),
  ]);

  const [trProducts, arProducts] = await Promise.all([
    trRes.json(),
    arRes.json(),
  ]);

  const maps = {
    tr: new Map(trProducts.map((p) => [p.id, p])),
    ar: new Map(arProducts.map((p) => [p.id, p])),
  };

  const selectedMap = maps[lang] || new Map();

  // EN (API) ürünü varsa göster, TR/AR varsa çevir
  return apiProducts.map((p) => {
    const localized = selectedMap.get(p.id);
    return {
      ...p,
      ...(localized || {}),
    };
  });
};

export const localizeCartItems = async (cartItems, lang = "en") => {
  const [trRes, arRes] = await Promise.all([
    fetch("/products/tr.json"),
    fetch("/products/ar.json"),
  ]);
  const [trProducts, arProducts] = await Promise.all([
    trRes.json(),
    arRes.json(),
  ]);

  const maps = {
    tr: new Map(trProducts.map((p) => [p.stock_code || p.id, p])),
    ar: new Map(arProducts.map((p) => [p.stock_code || p.id, p])),
  };

  const selectedMap = maps[lang] || new Map();

  return cartItems.map((item) => {
    const localized = selectedMap.get(item.stock_code || item.id);
    return {
      ...item,
      ...(localized || {}),
    };
  });
};
